import React, { useState } from 'react';
import { Button } from '../ui/button';
import { FUNDING_PRODUCT_TYPES } from '../../utils/funding/constants';

const inputClass = 'w-full rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingLenderProductForm = ({ onSubmit, onCancel, saving }) => {
  const [form, setForm] = useState({
    name: '',
    product_type: 'Term Loan',
    min_amount: '',
    max_amount: '',
    min_credit_score: '',
    estimated_speed_days: '',
    pricing_notes: '',
    status: 'Active',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      name: form.name.trim() || form.product_type,
      product_type: form.product_type,
      min_amount: form.min_amount ? Number(form.min_amount) : null,
      max_amount: form.max_amount ? Number(form.max_amount) : null,
      min_credit_score: form.min_credit_score ? Number(form.min_credit_score) : null,
      estimated_speed_days: form.estimated_speed_days ? Number(form.estimated_speed_days) : null,
      pricing_notes: form.pricing_notes || null,
      status: form.status,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-3 md:grid-cols-2">
      <input className={inputClass} value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="Product name" />
      <select className={inputClass} value={form.product_type} onChange={(e) => setForm((p) => ({ ...p, product_type: e.target.value }))}>
        {FUNDING_PRODUCT_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
      <input className={inputClass} type="number" value={form.min_amount} onChange={(e) => setForm((p) => ({ ...p, min_amount: e.target.value }))} placeholder="Min amount" />
      <input className={inputClass} type="number" value={form.max_amount} onChange={(e) => setForm((p) => ({ ...p, max_amount: e.target.value }))} placeholder="Max amount" />
      <input className={inputClass} type="number" value={form.min_credit_score} onChange={(e) => setForm((p) => ({ ...p, min_credit_score: e.target.value }))} placeholder="Min credit score" />
      <input className={inputClass} type="number" value={form.estimated_speed_days} onChange={(e) => setForm((p) => ({ ...p, estimated_speed_days: e.target.value }))} placeholder="Estimated speed (days)" />
      <textarea className={`${inputClass} md:col-span-2`} rows={2} value={form.pricing_notes} onChange={(e) => setForm((p) => ({ ...p, pricing_notes: e.target.value }))} placeholder="Pricing notes" />
      <div className="md:col-span-2 flex gap-2">
        <Button type="submit" disabled={saving}>{saving ? 'Saving...' : 'Add product'}</Button>
        {onCancel ? <Button type="button" variant="ghost" onClick={onCancel}>Cancel</Button> : null}
      </div>
    </form>
  );
};

export default FundingLenderProductForm;
